export const ChartLegend = {
  flow: 'y',
  gap: 'Y',
  padding: 'Z A',
  background: 'inkMid',
  round: 'Y',
  border: '1px solid inkBorder',

  LegendToggle: {
    flow: 'x',
    align: 'center space-between',
    cursor: 'pointer',
    onClick: (el, s) => {
      s.root.update({ legendOpen: !s.root.legendOpen })
    },

    LegendTitle: {
      text: '{{ chartLegend | polyglot }}',
      fontSize: 'Y',
      fontWeight: '600',
      color: 'inkMuted',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    ToggleIcon: {
      extends: 'Icon',
      icon: (el, s) => s.root.legendOpen ? 'chevronUp' : 'chevronDown',
      fontSize: 'Z',
      color: 'inkMuted'
    }
  },

  LegendItems: {
    show: (el, s) => s.root.legendOpen !== false,
    flow: 'x',
    gap: 'Z',
    flexWrap: 'wrap',
    paddingTop: 'Y',

    Healthy: { flow: 'x', gap: 'X', align: 'center flex-start', Swatch: { width: 'Y', height: 'Y', round: 'C', background: 'toothHealthy', border: '1px solid inkBorder' }, Label: { tag: 'span', text: '{{ healthy | polyglot }}', fontSize: 'Y', color: 'inkText', fontWeight: '500' } },
    Caries: { flow: 'x', gap: 'X', align: 'center flex-start', Swatch: { width: 'Y', height: 'Y', round: 'C', background: 'toothCaries', border: '1px solid inkBorder' }, Label: { tag: 'span', text: '{{ caries | polyglot }}', fontSize: 'Y', color: 'inkText', fontWeight: '500' } },
    Restored: { flow: 'x', gap: 'X', align: 'center flex-start', Swatch: { width: 'Y', height: 'Y', round: 'C', background: 'toothRestored', border: '1px solid inkBorder' }, Label: { tag: 'span', text: '{{ restored | polyglot }}', fontSize: 'Y', color: 'inkText', fontWeight: '500' } },
    Crown: { flow: 'x', gap: 'X', align: 'center flex-start', Swatch: { width: 'Y', height: 'Y', round: 'C', background: 'toothCrown', border: '1px solid inkBorder' }, Label: { tag: 'span', text: '{{ crownStatus | polyglot }}', fontSize: 'Y', color: 'inkText', fontWeight: '500' } },
    Implant: { flow: 'x', gap: 'X', align: 'center flex-start', Swatch: { width: 'Y', height: 'Y', round: 'C', background: 'toothImplant', border: '1px solid inkBorder' }, Label: { tag: 'span', text: '{{ implant | polyglot }}', fontSize: 'Y', color: 'inkText', fontWeight: '500' } },
    Braces: { flow: 'x', gap: 'X', align: 'center flex-start', Swatch: { width: 'Y', height: 'Y', round: 'C', background: 'toothBraces', border: '1px solid inkBorder' }, Label: { tag: 'span', text: '{{ braces | polyglot }}', fontSize: 'Y', color: 'inkText', fontWeight: '500' } },
    Missing: { flow: 'x', gap: 'X', align: 'center flex-start', Swatch: { width: 'Y', height: 'Y', round: 'C', background: 'toothMissing', border: '1px solid inkBorder' }, Label: { tag: 'span', text: '{{ missing | polyglot }}', fontSize: 'Y', color: 'inkText', fontWeight: '500' } },
    Bridge: { flow: 'x', gap: 'X', align: 'center flex-start', Swatch: { width: 'Y', height: 'Y', round: 'C', background: 'toothBridge', border: '1px dashed blue' }, Label: { tag: 'span', text: '{{ bridge | polyglot }}', fontSize: 'Y', color: 'inkText', fontWeight: '500' } }
  }
}
